import { render, staticRenderFns } from "./iv.vue?vue&type=template&id=bf09b262&"
import script from "./iv.vue?vue&type=script&lang=js&"
export * from "./iv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports